/**
 * Inyeccion del cliente de la API en el arbol de componentes.
 *
 * Las pantallas dependen de la interfaz `MonitorApi`, nunca de `fetch`. Un test
 * monta la pantalla con una implementacion falsa y no necesita mockear la red.
 */
import { createContext, useContext } from 'react';
import type { ReactElement, ReactNode } from 'react';
import type { MonitorApi } from '../api/monitor-api';

const MonitorApiContext = createContext<MonitorApi | null>(null);

export interface MonitorApiProviderProps {
  readonly api: MonitorApi;
  readonly children: ReactNode;
}

export function MonitorApiProvider({ api, children }: MonitorApiProviderProps): ReactElement {
  return <MonitorApiContext.Provider value={api}>{children}</MonitorApiContext.Provider>;
}

/** Cliente de la API. Falla ruidosamente si falta el provider. */
export function useMonitorApi(): MonitorApi {
  const api = useContext(MonitorApiContext);
  if (api === null) {
    throw new Error('useMonitorApi requiere que el arbol este dentro de <MonitorApiProvider>.');
  }
  return api;
}
